import { StoreScopedIntentBuilder } from './StoreScopedIntentBuilder';

/** Physical product: store + listing + optional variant / quantity. */
export class ProductIntentBuilder extends StoreScopedIntentBuilder {
  listing(listingId: string): this {
    this.root.param('listing_id', listingId);
    return this;
  }

  variant(variantId: string): this {
    this.root.param('variant', variantId);
    return this;
  }

  quantity(qty: number): this {
    this.root.param('qty', qty);
    return this;
  }
}
